// extracted by mini-css-extract-plugin
export default {"Toast":"toaster_Toast__Y1jkK","Icon":"toaster_Icon__gcz5o","Success":"toaster_Success__9-CKL"};